<template>
  <nav id="breadcrumb" aria-label="breadcrumb" class="border-bottom">
    <b-breadcrumb :items="$route.meta.routePath" />
    <!-- END BREADCRUMB -->
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb"
};
</script>

<style scoped>
.breadcrumb {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
  border-radius: 0;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: ">";
}
</style>
